import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import { ReactComponent as MagnificationLogo } from '../../img/magnificationlensicon.svg'
import { ReactComponent as FilterLogo } from '../../img/filtericon.svg'
import { instance2 } from '../../utils/axiosInstance';
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { toast } from "sonner";

export default function LocationTable() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  
const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);



  // open modal
  const handleOpenEdit = (item) => {
    setSelectedLocation(item);
    setIsEditOpen(true);
  };
    const fetchData = async () => {
      try {
        const response = await instance2.get("location"); // Use instance2 for the API call
  
        setData(response.data); // Set data from Axios response
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
  useEffect(() => {
    fetchData();
  }, []);
  

  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  const filteredData = data.filter((item) => {
    const searchValue = searchQuery.toLowerCase();
  
    return (
      (item.location_name?.toLowerCase() || "").includes(searchValue) || // Check if location_name exists
      (item.district_name?.toLowerCase() || "").includes(searchValue) || // Check if district_name exists
      (item.regency_name?.toLowerCase() || "").includes(searchValue) || // Check if regency_name exists
      (item.description?.toLowerCase() || "").includes(searchValue) // Check if description exists
    );
  });

const [currentPage, setCurrentPage] = useState(1);
         const itemsPerPage = 10;
       
         const totalPages = Math.ceil(filteredData.length / itemsPerPage);
         const paginatedData = filteredData.slice(
           (currentPage - 1) * itemsPerPage,
           currentPage * itemsPerPage
         );
       
         const handlePreviousPage = () => {
           if (currentPage > 1) setCurrentPage(currentPage - 1);
         };
       
         const handleNextPage = () => {
           if (currentPage < totalPages) setCurrentPage(currentPage + 1);
         };
       
         // Determine which page numbers to show
         let pageNumbers = [];
         const maxVisiblePages = 5;
       
         if (totalPages <= maxVisiblePages) {
           pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
         } else {
           if (currentPage <= 3) {
             // Near the beginning
             pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
           } else if (currentPage >= totalPages - 2) {
             // Near the end
             pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
           } else {
             // In the middle
             pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
           }
         }

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this data? This action cannot be undone."
    );
  
    if (!confirmDelete) {
      return; // Exit if the user cancels the deletion
    }
  
    try {
      const response = await instance2.delete(`location/${id}`); // Replace `kitchen` with your endpoint
  
      if (response.status === "OK") {
        alert("Data deleted successfully!");
        // Remove the deleted row from the table
        setData((prevData) => prevData.filter((item) => item.id !== id));
      } else {
        alert("Failed to delete data. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      alert("An error occurred while deleting the data.");
    }
  };

  return (
    <div className="p-4">
      <div className="flex flex-col items-start md:flex-row lg:flex-row md:items-center lg:items-center justify-between">
        <h2 className="text-lg font-bold">Daftar Koperasi</h2>
        <button
          type="button"
          onClick={() => navigate('/inputlocation')}
          className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
        >
          Tambah Data Koperasi
        </button>
      </div>
      
      {/* Search Bar */}
      <div className="flex py-2 rounded-[50px] flex-row justify-start items-center gap-2">
      <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-lg items-center justify-start">
        <MagnificationLogo className="h-6 w-6" />
        <VerticalLine className="mx-1" />
        <input
          type="text"
          placeholder="Cari pemasok atau tanggal"
          className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
          style={{
            width: `${"Cari pemasok atau tanggal".length}ch`,
          }}
          value={searchQuery} // Controlled input
          onChange={(e) => setSearchQuery(e.target.value)} // Update search query
        />
      </div>
      
      {/* Filter Icon */}
      {/* <div className="text-gray-400">
        <FilterLogo />
      </div> */}
      </div>
      <table className="table-fixed w-full border-collapse text-left">
        <thead>
          <tr className="bg-white">
            <th
              className="w-[50px] border-b border-gray-300 px-4 py-2 rounded-tl-[15px] text-center text-xxs md:text-xxs lg:text-base"
              onClick={() => handleSort('id')}
            >
              No <span className="float-right">{getSortArrow('id')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
              onClick={() => handleSort('location_name')}
            >
              Koperasi <span className="float-right">{getSortArrow('location_name')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
              onClick={() => handleSort('district_name')}
            >
              Kecamatan <span className="float-right">{getSortArrow('district_name')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
              onClick={() => handleSort('regency_name')}
            >
              Kota <span className="float-right">{getSortArrow('regency_name')}</span>
            </th>
            {/* <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
              onClick={() => handleSort('description')}
            >
              Deskripsi <span className="float-right">{getSortArrow('description')}</span>
            </th> */}
            <th className="border-b border-gray-300 px-4 py-2 rounded-tr-[15px] text-center text-xxs md:text-xxs lg:text-base">Aksi</th>
          </tr>
        </thead>
        <tbody>
                  {[
            ...paginatedData,
            ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
              empty: true, // Add an "empty" object for invisible rows
            })),
          ].map((item, index) => (
            <tr
              key={item.id}
              className={`hover:bg-gray-200 ${
                index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
              } ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300"}`}
            >
              <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{index + 1 + (currentPage - 1) * itemsPerPage}</td>
              <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.location_name}</td>
              <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.district_name}</td>
              <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.regency_name}</td>
              {/* <td className="py-2 text-xxs md:text-xxs lg:text-base">{item.description}</td> */}
              <td className="py-2 text-center text-xxs md:text-xxs lg:text-base">
                <div className="flex justify-center items-center gap-2">
                  <button
                    className="text-gray-500 p-2 rounded hover:bg-blue-400"
                  onClick={() => handleOpenEdit(item)}  // 👈 open modal
                  >
                    <EditIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                  </button>
                  <button
                    className="text-gray-500 p-2 rounded hover:bg-red-400"
                  >
                    <TrashIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5"
                    onClick={() =>handleDelete(item.id)} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
        {/* 👇 Edit Modal */}
      {isEditOpen && selectedLocation && (
  <EditLocationModal
    item={selectedLocation}
    onClose={() => setIsEditOpen(false)}
    onSaved={() => { setIsEditOpen(false); fetchData(); }} // refetch table
  />
)}
    </div>
  );
}


function EditLocationModal({ item, onClose, onSaved }) {
  const [formData, setFormData] = useState({
    name: "",
    location_id: "",   // Regency ID
    description: "",
    admin_id: "",
    district_id: "",   // District ID
    village_id: "",    // Village CODE
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Lists
  const [location, setLocation] = useState([]);  // regencies
  const [district, setDistrict] = useState([]);  // districts
  const [village, setVillage]   = useState([]);  // villages

  // Per-field loading flags (spinners)
  const [isRegLoading,  setIsRegLoading]  = useState(false);
  const [isDistLoading, setIsDistLoading] = useState(false);
  const [isVillLoading, setIsVillLoading] = useState(false);

  const [user, setUser] = useState("");
  const [userId, setUserId] = useState("");

  // Search labels
  const [searchRegTerm,  setSearchRegTerm]  = useState("");
  const [searchDistTerm, setSearchDistTerm] = useState("");
  const [searchVillTerm, setSearchVillTerm] = useState("");

  // Dropdown toggles
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDistrictOpen, setIsDistrictOpen] = useState(false);
  const [isVillageOpen,  setIsVillageOpen]  = useState(false);

  const dropdownRef = useRef(null);

  // Prefill guards so item-based prefill happens only once
  const shouldPrefillDistrict = useRef(true);
  const shouldPrefillVillage  = useRef(true);

  // Simple inline spinner
  const Spinner = () => (
    <svg className="animate-spin h-4 w-4 ml-2 inline-block text-gray-500" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"/>
    </svg>
  );

  // ---------- Prefill base fields & current user ----------
  useEffect(() => {
    const storedUser = localStorage.getItem("userAuthentication");
    if (storedUser) setUser(storedUser);

    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(parseInt(storedUserId, 10));
    }

    setFormData(prev => ({
      ...prev,
      name: item?.location_name || "",
      description: item?.description || "",
      admin_id: storedUser ,
      district_id: "",
      village_id: "",
    }));
    setSearchRegTerm(item?.regency_name || "");
    setSearchDistTerm(item?.district_name || "");
    setSearchVillTerm(item?.village_name || "");
  }, [item]);

  // ---------- Load regencies, then resolve & set location_id ----------
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setIsRegLoading(true);
        const res = await instance2.get("regency");
        const regData = res.data.map(loc => ({ id: loc.id, name: loc.name, code: loc.code }));
        if (!mounted) return;
        setLocation(regData);

        if (item?.regency_name) {
          const match = regData.find(
            r => (r.name || "").toLowerCase() === (item.regency_name || "").toLowerCase()
          );
          if (match) {
            setFormData(prev => ({ ...prev, location_id: match.id }));
          }
        }
      } catch (err) {
        console.error("Failed to fetch regencies", err);
        setError(err.response?.data?.message || "Failed to fetch regencies");
      } finally {
        if (mounted) setIsRegLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [item?.regency_name]);

  const filteredLocations = location.filter((loc) =>
    (loc.name || "").toLowerCase().includes((searchRegTerm || "").toLowerCase())
  );

  // ---------- When location_id known, load districts & maybe prefill ----------
  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!formData.location_id) return;
      try {
        setIsDistLoading(true);
        const res = await instance2.get(`districts/regency/${formData.location_id}`);
        const distData = res.data.map(loc => ({ id: loc.id, name: loc.name, code: loc.code }));
        if (!mounted) return;
        setDistrict(distData);

        if (item?.district_name && shouldPrefillDistrict.current) {
          const match = distData.find(
            d => (d.name || "").toLowerCase() === (item.district_name || "").toLowerCase()
          );
          if (match) {
            setFormData(prev => ({ ...prev, district_id: match.code }));
            setSearchDistTerm(match.name);
          }
          // stop further auto-prefills
          shouldPrefillDistrict.current = false;
        }
      } catch (err) {
        console.error("Failed to fetch districts", err);
        setError(err.response?.data?.message || "Failed to fetch districts");
      } finally {
        if (mounted) setIsDistLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [formData.location_id, item?.district_name]);

  const filteredDistrict = district.filter((loc) =>
    (loc.name || "").toLowerCase().includes((searchDistTerm || "").toLowerCase())
  );

  // ---------- When district_id known, load villages & maybe prefill ----------
  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!formData.district_id) return;
      try {
        setIsVillLoading(true);
        const res = await instance2.get(`villages/district/${formData.district_id}`);
        const villData = res.data.map(loc => ({ id: loc.id, name: loc.name, code: loc.code }));
        if (!mounted) return;
        setVillage(villData);

        if (item?.village_name && shouldPrefillVillage.current) {
          const match = villData.find(
            v => (v.name || "").toLowerCase() === (item.village_name || "").toLowerCase()
          );
          if (match) {
            setFormData(prev => ({ ...prev, village_id: match.code }));
            setSearchVillTerm(match.name);
          }
          // stop further auto-prefills
          shouldPrefillVillage.current = false;
        }
      } catch (err) {
        console.error("Failed to fetch villages", err);
        setError(err.response?.data?.message || "Failed to fetch villages");
      } finally {
        if (mounted) setIsVillLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [formData.district_id, item?.village_name]);

  const filteredVillage = village.filter((loc) =>
    (loc.name || "").toLowerCase().includes((searchVillTerm || "").toLowerCase())
  );

  // -------- outside click for the first dropdown --------
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // -------- submit (PUT) --------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    try {
      const payload = {
        name: formData.name,
        location_id: formData.location_id, // regency ID
        description: formData.description,
        admin_id: formData.admin_id,
        district_id: formData.district_id, // district ID
        village_id: formData.village_id,   // village CODE
      };
      const res = await instance2.put(`location/${item.id}`, payload);
      if (res.status = "OK") {
        toast.success("Lokasi Berhasil Diperbarui");
        onSaved?.();
        onClose?.();
      } else {
        setError("Gagal memperbarui lokasi. Mohon coba lagi.");
      }
    } catch (err) {
      console.error("Error:", err);
      setError(err.response?.data?.message || "Gagal memperbarui lokasi. Mohon coba lagi.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // -------- clear dependents when upper level changes (and stop auto-prefill) --------
  const prevLocationIdRef = useRef(formData.location_id);
  const prevDistrictIdRef  = useRef(formData.district_id);

  useEffect(() => {
    const prev = prevLocationIdRef.current;
    if (prev && prev !== formData.location_id) {
      setFormData(prevData => ({ ...prevData, district_id: "", village_id: "" }));
      setSearchDistTerm("");
      setSearchVillTerm("");
      setVillage([]);
      shouldPrefillDistrict.current = false;
      shouldPrefillVillage.current  = false;
    }
    prevLocationIdRef.current = formData.location_id;
  }, [formData.location_id]);

  useEffect(() => {
    const prev = prevDistrictIdRef.current;
    if (prev && prev !== formData.district_id) {
      setFormData(prevData => ({ ...prevData, village_id: "" }));
      setSearchVillTerm("");
      shouldPrefillVillage.current = false;
    }
    prevDistrictIdRef.current = formData.district_id;
  }, [formData.district_id]);

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
      <div className="bg-white rounded-xl p-6 w-[95%] max-w-md">
        <h2 className="text-lg font-bold mb-4">Ubah Data Koperasi</h2>

        <form onSubmit={handleSubmit}>
          {/* Name */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">
              Nama Koperasi
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={e => setFormData(prev => ({ ...prev, name: e.target.value }))}
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
              placeholder="Masukkan Nama Koperasi"
              required
            />
          </div>

          {/* Regency */}
          <div className="mb-4 relative" ref={dropdownRef}>
            <label className="block text-gray-700 mb-2">
              Kota/Kabupaten
              {isRegLoading && <Spinner />}
            </label>
            <div className="relative">
              <input
                type="text"
                placeholder="Pilih Kota/Kabupaten"
                value={searchRegTerm}
                onChange={(e) => setSearchRegTerm(e.target.value)}
                onFocus={() => !isRegLoading && setIsDropdownOpen(true)}
                className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none disabled:bg-gray-100"
                disabled={isRegLoading}
              />
              <div
                className={`absolute inset-y-0 right-3 flex items-center ${isRegLoading ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                onClick={() => !isRegLoading && setIsDropdownOpen(prev => !prev)}
              >
                <svg
                  className={`w-4 h-4 transition-transform ${isDropdownOpen ? "rotate-180" : "rotate-0"}`}
                  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

            {isDropdownOpen && (
              <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
                {isRegLoading ? (
                  <div className="px-4 py-3 text-sm text-gray-500 flex items-center">
                    Memuat data… <Spinner />
                  </div>
                ) : filteredLocations.length > 0 ? (
                  filteredLocations.map((loc) => (
                    <div
                      key={loc.id}
                      className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                      onMouseDown={() => {
                        setFormData(prev => ({
                          ...prev,
                          location_id: loc.id,
                          district_id: "",
                          village_id: "",
                        }));
                        setSearchRegTerm(loc.name);
                        setSearchDistTerm("");
                        setSearchVillTerm("");
                        shouldPrefillDistrict.current = false;
                        shouldPrefillVillage.current  = false;
                        setIsDropdownOpen(false);
                      }}
                    >
                      {loc.name}
                    </div>
                  ))
                ) : (
                  <div className="px-4 py-2 text-sm text-gray-500">No locations found</div>
                )}
              </div>
            )}
          </div>

          {/* District */}
          <div className="mb-4 relative">
            <label className="block text-gray-700 mb-2">
              Kecamatan
              {isDistLoading && <Spinner />}
            </label>
            <div className="relative">
              <input
                type="text"
                placeholder="Pilih Kecamatan"
                value={searchDistTerm}
                onChange={(e) => setSearchDistTerm(e.target.value)}
                onFocus={() => !isDistLoading && setIsDistrictOpen(true)}
                className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none disabled:bg-gray-100"
                disabled={isDistLoading || !formData.location_id}
              />
              <div
                className={`absolute inset-y-0 right-3 flex items-center ${isDistLoading ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                onClick={() => !isDistLoading && setIsDistrictOpen(prev => !prev)}
              >
                <svg
                  className={`w-4 h-4 transition-transform ${isDistrictOpen ? "rotate-180" : "rotate-0"}`}
                  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

            {isDistrictOpen && (
              <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
                {isDistLoading ? (
                  <div className="px-4 py-3 text-sm text-gray-500 flex items-center">
                    Memuat kecamatan… <Spinner />
                  </div>
                ) : filteredDistrict.length > 0 ? (
                  filteredDistrict.map((loc) => (
                    <div
                      key={loc.id}
                      className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                      onMouseDown={() => {
                        setFormData(prev => ({
                          ...prev,
                          district_id: loc.code, // use ID
                          village_id: "",
                        }));
                        setSearchDistTerm(loc.name);
                        setSearchVillTerm("");
                        shouldPrefillVillage.current = false;
                        setIsDistrictOpen(false);
                      }}
                    >
                      {loc.name}
                    </div>
                  ))
                ) : (
                  <div className="px-4 py-2 text-sm text-gray-500">No district found</div>
                )}
              </div>
            )}
          </div>

          {/* Village */}
          <div className="mb-4 relative">
            <label className="block text-gray-700 mb-2">
              Kelurahan
              {isVillLoading && <Spinner />}
            </label>
            <div className="relative">
              <input
                type="text"
                placeholder="Pilih Kelurahan/Desa"
                value={searchVillTerm}
                onChange={(e) => setSearchVillTerm(e.target.value)}
                onFocus={() => !isVillLoading && setIsVillageOpen(true)}
                className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none disabled:bg-gray-100"
                disabled={isVillLoading || !formData.district_id}
              />
              <div
                className={`absolute inset-y-0 right-3 flex items-center ${isVillLoading ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                onClick={() => !isVillLoading && setIsVillageOpen(prev => !prev)}
              >
                <svg
                  className={`w-4 h-4 transition-transform ${isVillageOpen ? "rotate-180" : "rotate-0"}`}
                  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

            {isVillageOpen && (
              <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
                {isVillLoading ? (
                  <div className="px-4 py-3 text-sm text-gray-500 flex items-center">
                    Memuat kelurahan… <Spinner />
                  </div>
                ) : filteredVillage.length > 0 ? (
                  filteredVillage.map((loc) => (
                    <div
                      key={loc.code}
                      className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                      onMouseDown={() => {
                        setFormData(prev => ({ ...prev, village_id: loc.code }));
                        setSearchVillTerm(loc.name);
                        setIsVillageOpen(false);
                      }}
                    >
                      {loc.name}
                    </div>
                  ))
                ) : (
                  <div className="px-4 py-2 text-sm text-gray-500">No village found</div>
                )}
              </div>
            )}
          </div>

          {/* Description */}
          {/* <div className="mb-4">
            <label className="block text-gray-700 mb-2">Deskripsi</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={e => setFormData(prev => ({ ...prev, description: e.target.value }))}
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
              placeholder="Masukkan Deskripsi"
            />
          </div> */}

          {/* Admin ID (read-only) */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Admin ID</label>
            <input
              type="text"
              name="admin_id"
              value={user}
              className="w-full px-3 border-none rounded-full bg-gray-200 text-xs py-4"
              placeholder="Admin ID"
              disabled
            />
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="px-4 py-2 rounded bg-gray-200"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Batal
            </button>
            <button
              type="submit"
              className={`px-4 py-2 bg-merah-no text-white rounded hover:bg-merah-hover ${
                isSubmitting || !formData.village_id ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={isSubmitting || !formData.village_id}
            >
              {isSubmitting ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>

        {error && <p className="text-red-500 mt-4">{error}</p>}
      </div>
    </div>
  );
}
